import {createRouter, createWebHashHistory} from 'vue-router'
import Index from '../views/Index.vue';
import Login from '../views/Login.vue';
import CheckCondition from '../views/CheckCondition.vue';

const routes = [
    {
        path: '/',
        name: 'Login',
        component: Login,
        // component: () => import('../views/EventManage/Hotline.vue')
    },
    // {
    //     path: '/',
    //     name: 'CheckCondition',
    //     component: CheckCondition,
    // },
    {
        path: '/Index',
        name: 'Index',
        component: Index,
        redirect: '/Hotline',
        children: [
            // {
            //     path: '/Jsjb',
            //     name: 'Jsjb',
            //     component: () => import('../views/EventManage/Jsjb.vue')
            // },
            {
                path: '/Home',
                name: 'Home',
                component: () => import('../views/Home/Home.vue')
            },

            {
                path: '/Jsjb_handInput',
                name: 'Jsjb_handInput',
                component: () => import('../views/EventManage/Jsjb_handInput.vue')
            },
            {
                path: '/Hotline',
                name: 'Hotline',
                component: () => import('../views/EventManage/Hotline.vue')
            },
            {
                path: '/CheckCondition',
                name: 'CheckCondition',
                component: () => import('../views/CheckCondition.vue')
            },
            {
                path: '/TotallAnalysis',
                name: 'TotallAnalysis',
                component: () => import('../views/TotallAnalysis/TotallAnalysis.vue')
            },
            {
                path: '/TimelineAll',
                name: 'TimelineAll',
                component: () => import('../components/EventManage/Jsjb/TimeLineAll.vue')
            },
            {
                path: '/AddressBook',
                name: 'AddressBook',
                component: () => import('../views/AddressBook/AddressBook.vue')
            },
            {
                path: '/FileDownload',
                name: 'FileDownload',
                component: () => import('../views/FileDownload/FileDownload.vue')
            },
        ]
    },
]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

export default router
